import React from "react";
import { useParams } from "react-router-dom";
import { ChatBot } from "../features/chatbot"; 

export default function ChatBotPage() {
  const { demandId } = useParams();
  return <ChatBot demandId={demandId || "DEM-001"} />;
}
